import { render, staticRenderFns } from "./peru.vue?vue&type=template&id=d497c73a&"
import script from "./peru.vue?vue&type=script&lang=js&"
export * from "./peru.vue?vue&type=script&lang=js&"
import style0 from "./peru.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CountryTop: require('/builds/pagsmile/front-end/pagsmile-web/components/countryGuides/CountryTop.vue').default,CountryDescription: require('/builds/pagsmile/front-end/pagsmile-web/components/countryGuides/CountryDescription.vue').default,CountryFeatures: require('/builds/pagsmile/front-end/pagsmile-web/components/countryGuides/CountryFeatures.vue').default,CountryChart: require('/builds/pagsmile/front-end/pagsmile-web/components/countryGuides/CountryChart.vue').default,CountryPaymentCard: require('/builds/pagsmile/front-end/pagsmile-web/components/countryGuides/CountryPaymentCard.vue').default,FooterTop: require('/builds/pagsmile/front-end/pagsmile-web/components/footer/footerTop.vue').default})
